<section fxLayout='column' fxLayoutAlign='center center' fxLayoutGap='30px'>
  <h1>MOBILE APP</h1>
  <div fxLayout='row' fxLayout.xs='column' fxLayoutAlign='start center'>
    <div fxFlex='1 1 40%' style='text-align:center' fxFlexOffset.gt-xs='20'>
      <img src='./assets/images/phones.png' width="80%">
    </div>
    <div fxLayout='column' fxLayoutAlign='start center' fxFlex='1 1 40%'>
      <div>
        <img src='./assets/images/logo-black-2.png' width="95%">
      </div>
    </div>
    <div fxFlex.gt-xs='1 1 20%'>

    </div>

  </div>
  <div>
    <button class='s18-primary-header-color' mat-raised-button (click)='startNow()'>DOWNLOAD THE APP</button>
  </div>
  <div fxHide fxShow.xs style='height:15px'>

  </div>
</section>